import * as React from "react";
import { useState, useEffect, useContext } from 'react';
import AddCircle from "@mui/icons-material/AddCircle";
import EraseIcon from "@mui/icons-material/Delete";
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { UserContext } from "../../App";
import Notification from "../../components/common/Notification";
import Parceiro from "../../components/classes/Parceiro";
import { useTranslation } from "react-i18next";

interface ParceiroModalProps {
    openDialog: boolean,
    setOpenDialog: any,
    parceiros: Parceiro[],
    parceirosVinculados: Parceiro[],
    setParceirosVinculados: any
}

export default function EmailsParceiroModal(props: ParceiroModalProps) {
    const { t } = useTranslation();
    const user: any = useContext(UserContext);

    const [rows, setRows] = useState<Parceiro[]>([]);

    const [parceiroSelecionado, setParceiroSelecionado] = useState<number>(0);
    const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })
    const columns: GridColumns = [
        {
            field: 'apelido',
            headerName: t("common.nickname"),
            flex: 1,
            editable: false,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => `${params.row.codigoFornecedorSAP} - ${params.row.apelido}`
        },
        {
            field: "deleteico", headerAlign: 'center', align: 'center', headerName: t("common.delete"), width: 100, renderCell: (cellValues) => {
                return (
                    <Tooltip title={t("common.delete")}>
                        <span>
                            <IconButton disabled={user.isSuporte} onClick={(event) => { removeParceiro(cellValues.row) }}>
                                <EraseIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        },
    ];

    const removeParceiro = (row: any) => {
        props.setParceirosVinculados(props.parceirosVinculados.filter(x => x.id != row.id));
    }

    return (
        <>
            <Dialog
                open={props.openDialog}
                onClose={() => props.setOpenDialog(false)}
                aria-labelledby="alert-dialog-title"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("pages.user.text.userRelatedPartners")}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3} marginTop={1} >
                        <Grid item xs={12} sm={9}>
                            <Box sx={{ minWidth: 300 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">{t("pages.user.text.partners")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={parceiroSelecionado}
                                        label={t("pages.user.text.partners")}
                                        onChange={(e) => setParceiroSelecionado(+e.target.value)}
                                        disabled={!user.isRoot}
                                        size="small"
                                    >
                                        {
                                            props.parceiros.map(x => <MenuItem value={+x.id}>{x.codigoFornecedorSAP} - {x.apelido}</MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button
                                variant='contained'
                                color="primary"
                                onClick={() => {
                                    let parc = props.parceiros.find(x => x.id == parceiroSelecionado);
                                    let exists = props.parceirosVinculados.find(x => x.id == parceiroSelecionado);
                                    if (parc && !exists) {
                                        props.setParceirosVinculados([...props.parceirosVinculados, parc])
                                        setParceiroSelecionado(0);
                                    }
                                }}
                                autoFocus
                                fullWidth
                            >
                                {t("common.add")}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ height: '60vh' }} >
                                <DataGrid
                                    rows={props.parceirosVinculados}
                                    columns={columns}
                                    rowsPerPageOptions={[5, 10, 25]}
                                    autoPageSize
                                    disableSelectionOnClick
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color="primary" onClick={() => props.setOpenDialog(false)} autoFocus>
                        {t("common.close")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Notification
                notify={notify}
                setNotify={setNotify}
            />
        </>
    );
}